import { useCurrentHashStore } from '../../stores/hashs/useCurrentHashStore';
import { useAvailableLinesStore } from '../../stores/hashs/useAvailableLinesStore';
import { useNotEscaletedLinesNextStore } from '../../stores/hashs/useNotEscaletedLinesNextStore';
import { useNotEscaletedLinesTodayStore } from '../../stores/hashs/useNotEscaletedLinesTodayStore';
import { useEscaletedLinesTodayStore } from '../../stores/hashs/useEscaletedLinesTodayStore';
import { useAlertN1Store } from '../../stores/hashs/useAlertN1Store';
import { useAlertN2Store } from '../../stores/hashs/useAlertN2Store';
import { useAlertN3Store } from '../../stores/hashs/useAlertN3Store';

import { useOrderStore } from '../../stores/useOrderStore';
import { selectSortedHashItems } from './selectHashListData';

export default function useHashListData() {

    const currentHash = useCurrentHashStore(
        state => state.currentHash
    );

    const availableData = useAvailableLinesStore(
        state => state.data
    );

    const notEscaletedLinesNextData = useNotEscaletedLinesNextStore(
        state => state.data
    );

    const notEscaletedLinesTodayData = useNotEscaletedLinesTodayStore(
        state => state.data
    );

    const escaletedLinesTodayData = useEscaletedLinesTodayStore(
        state => state.data
    );

    const alertN1Data = useAlertN1Store(
        state => state.data
    );

    const alertN2Data = useAlertN2Store(
        state => state.data
    );

    const alertN3Data = useAlertN3Store(
        state => state.data
    );

    const order = useOrderStore(state => state.order);
    const orderASC = useOrderStore(state => state.orderASC);
    const orderTypes = useOrderStore(state => state.orderTypes);

    const sortedItems = selectSortedHashItems({
        currentHash,
        availableData,
        notEscaletedLinesNextData,
        notEscaletedLinesTodayData,
        escaletedLinesTodayData,
        alertN1Data,
        alertN2Data,
        alertN3Data,
        order,
        orderASC,
        orderTypes
    });

    return {
        sortedItems
    };

}